import { WebAuth, } from 'auth0-js';
import Vue from 'vue';
import baseHttp from '@/plugins/baseHttp';
// TODO: Revisar renovação de token

// exchange the object with your own from the setup step above.
const auth0 = new WebAuth({
  domain: process.env.VUE_APP_AUTH0_DOMAIN,
  clientID: process.env.VUE_APP_AUTH0_CLIENTID,
  // make sure this line is contains the port: 8080
  redirectUri: process.env.VUE_APP_AUTH0_REDIRECTURI,
  // we will use the api/v2/ to access the user information as payload
  audience: process.env.VUE_APP_AUTH0_AUDIENCE,
  responseType: 'token id_token',
  returnTo: process.env.VUE_APP_AUTH0_RETURNTO,
  scope: 'openid profile', // define the scopes you want to use
},);

let auth = new Vue({
  computed: {
    token: {
      get: function () {
        return localStorage.getItem('id_token',);
      },
      set: function (id_token,) {
        localStorage.setItem('id_token', id_token,);
      },
    },
    accessToken: {
      get: function () {
        return localStorage.getItem('access_token',);
      },
      set: function (accessToken,) {
        localStorage.setItem('access_token', accessToken,);
      },
    },
    expiresAt: {
      get: function () {
        return localStorage.getItem('expires_at',);
      },
      set: function (expiresIn,) {
        let expiresAt = JSON.stringify(expiresIn * 1000 + new Date().getTime(),);
        localStorage.setItem('expires_at', expiresAt,);
      },
    },
    user: {
      get: function () {
        return JSON.parse(localStorage.getItem('user',),);
      },
      set: function (user,) {
        localStorage.setItem('user', JSON.stringify(user,),);
      },
    },
  },
  methods: {
    login () {
      auth0.authorize();
    },
    renewToken () {
      console.log('[RENEW_TOKEN] method called',);
      if (!this.isAuthenticated()) {return;}
      return new Promise((resolve, reject,) => {
        auth0.checkSession({}, (err, authResult,) => {
          this.authHandler(resolve, reject, err, authResult,);
        },);
      },);
    },
    logout () {
      return new Promise(() => {
        localStorage.removeItem('access_token',);
        localStorage.removeItem('id_token',);
        localStorage.removeItem('expires_at',);
        localStorage.removeItem('user',);
        auth0.logout({
          // Allowed logout URL listed in dashboard
          returnTo: process.env.VUE_APP_AUTH0_RETURNTO,
          // Your client ID
          clientID: process.env.VUE_APP_AUTH0_CLIENTID,
        },);
      },);
    },
    isValidToken () {
      return new Date().getTime() < this.expiresAt;
    },
    isAuthenticated () {
      return !!localStorage.getItem('access_token',);
    },
    getUser () {
      return this.user;
    },
    getToken () {
      return localStorage.getItem('access_token',);
    },
    getStoredUser () {
      return JSON.parse(localStorage.getItem('user',),);
    },
    setStoredUser (user,) {
      this.user = user;
    },
    async findPermissions () {
      baseHttp.setAccessToken(this.getToken(),);
      return baseHttp.get('/backoffice/users/callback',).then(({ data, },) => data,).catch((err,) => baseHttp.handleError(err,),);
    },
    async authHandler (resolve, reject, err, authResult,) {
      if (authResult && authResult.accessToken && authResult.idToken) {
        this.token = authResult.idToken;
        this.expiresAt = authResult.expiresIn;
        this.accessToken = authResult.accessToken;

        const roosterPermissions = await this.findPermissions();
        const auth0Permissions = await authResult.idTokenPayload;

        this.user = { ...auth0Permissions, ...roosterPermissions, };

        resolve(this.getStoredUser(),);
      } else if (err) {
        this.logout();
        reject(err,);
      }
    },
    handleAuthentication () {
      return new Promise((resolve, reject,) => {
        auth0.parseHash((err, authResult,) => {
          this.authHandler(resolve, reject, err, authResult,);
        },);
      },);
    },
  },
},);

export default {
  install: function (Vue,) {
    Vue.prototype.$auth = auth;
  },
};
